import Models from "../Models/Models";

export default function DashboardModels() {
  return <Models is_admin_page />;
}
